/**
 * Moderation resource — banned/blocked visitors (parity). All endpoints admin-gated server-side.
 */

import type { HttpClient } from '../httpClient';
import { endpoints } from '../endpoints';
import type { BlockedVisitor } from '../../types';

export class ModerationResource {
  constructor(private readonly http: HttpClient) {}

  /** Ban a visitor by customer id (optional reason). */
  block(customerId: string, reason?: string): Promise<BlockedVisitor> {
    return this.http.post(endpoints.moderation.block(customerId), { reason });
  }

  /** Lift a ban. */
  unblock(customerId: string): Promise<BlockedVisitor> {
    return this.http.post(endpoints.moderation.unblock(customerId));
  }

  /** List currently-banned visitors (newest ban first). */
  listBanned(): Promise<BlockedVisitor[]> {
    return this.http.get(endpoints.moderation.banned());
  }
}
